import React, { useDebugValue, useEffect, useState } from "react";

import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  
  Input,
  Button,
  Spinner,
  Badge,
  FormGroup,
} from "reactstrap";
import { MdModeEdit, MdDelete } from "react-icons/md";
// import { HiEye } from "react-icons/hi";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { formatedDate } from "utils/common";

function TransactionHistory() {
  const [escrowRequest, setEscrowRequestData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [counting, setCounting] = useState([]);
  const pageSize = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [transactionStatus, setTransactionStatus] = useState("all");
  const user = useSelector((state) => state.user);
  console.log(user, "user");

  const fetchEscrowRequest = async (pageNumber = currentPage, query = "", transactionStatus) => {
    try {
      setLoader(true);
      const getAllRequest = await ApiClient.get(
        `api/payment/get-transaction-history?page=${pageNumber}&limit=${pageSize}&searchText=${query}&status=${transactionStatus}`,
        "",
        true,
        dispatch
      );
      setEscrowRequestData(getAllRequest.body.result);
      setCounting(getAllRequest.body);
      setLoader(false);
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchEscrowRequest(currentPage, searchQuery, transactionStatus);
  }, [currentPage, searchQuery, transactionStatus]);

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <div className="content">
      <div className="content-headline d-flex justify-content-between">
        <h4>Transaction History</h4>
      </div>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="5"></Col>
                  <Col md="4">
                    <form>
                      <InputGroup className="no-border">
                        <Input
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                          <InputGroupText>
                            <i className="nc-icon nc-zoom-split" />
                          </InputGroupText>
                      </InputGroup>
                    </form>
                  </Col>
                  <Col md="3">
                  <FormGroup>
                      <Input
                        type="select"
                        name="gender"
                        id="gender"
                        value={transactionStatus}
                        onChange={(e) => setTransactionStatus(e.target.value)}
                      >
                        <option value="all">All Transaction</option>
                        <option value="completed">Completed</option>
                        <option value="successfull">Successful</option>
                        <option value="created">Created</option>
                        <option value="cancelled">Cancelled</option>
                        <option value="pending">Pending</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {loader && (
                  <span className="table-loader">
                    <Spinner color="primary">Loading...</Spinner>
                  </span>
                )}
                {!loader && (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Transaction ID</th>
                          <th>Provider Name </th>
                          <th>Customer Name</th>
                          <th>Total Amount</th>
                          <th>Payment Status</th>
                          <th>Created Date</th>
                          <th>Payment Released</th>
                        </tr>
                      </thead>
                      <tbody>
                        {escrowRequest?.map((request) => (
                          <tr key={request._id}>
                            <td>{request?.transactionId}</td>
                            <td>{request?.providerFullName}</td>
                            <td>{request?.customerFullName}</td>
                            <td>R {request?.totalAmount}</td>
                            <td>{request?.status}</td>
                            <td>{formatedDate(request?.createdAt)}</td>
                            <td style={{textAlign: 'center'}}>
                            {" "}
                              {request?.isReleased ? (
                                <Badge style={{fontSize: '14px', backgroundColor: 'green'}} pill>
                                  yes
                                </Badge>
                              ) : (
                                <Badge style={{fontSize: '14px', backgroundColor: 'red'}} pill>
                                  no
                                </Badge>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="pagination d-flex justify-content-center align-items-center">
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="common-button"
                      >
                        Previous
                      </Button>
                      <span className="mx-3">
                        Page {counting?.currentPage} of {counting?.totalPages}
                      </span>
                      <span className="mx-3">
                        <strong>Total records: </strong>
                        {counting?.totalRecords}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === counting?.totalPages}
                        className="common-button"
                      >
                        Next
                      </Button>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default TransactionHistory;
